import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const ProtectedRoute = ({
  children,
  requiredPermission = null,
  requiredCargo = null,
  requiredOrganization = null,
}) => {
  const { isLoggedIn, loading, hasPermission, currentUser } = useAuth();

  // Exibir indicador de carregamento enquanto verifica autenticação
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // Redirecionar para login se não estiver autenticado
  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }

  // Verificar permissão específica, se necessário
  if (requiredPermission) {
    // Suportar array de permissões ou permissão única
    const allowedPermissions = Array.isArray(requiredPermission)
      ? requiredPermission
      : [requiredPermission];

    // Verificar se tem pelo menos uma das permissões
    const hasAnyPermission = allowedPermissions.some(perm => hasPermission(perm));

    if (!hasAnyPermission) {
      return <Navigate to="/dashboard" />;
    }
  }

  // Verificar cargo específico, se necessário
  if (requiredCargo) {
    const allowedCargos = Array.isArray(requiredCargo)
      ? requiredCargo
      : [requiredCargo];
    if (
      !allowedCargos.includes(currentUser?.cargo) &&
      currentUser?.cargo !== 'super_admin'
    ) {
      return <Navigate to="/dashboard" />;
    }
  }

  // Verificar organização específica, se necessário
  if (requiredOrganization) {
    if (
      currentUser?.currentOrganization?.name !== requiredOrganization &&
      currentUser?.cargo !== 'super_admin'
    ) {
      return <Navigate to="/dashboard" />;
    }
  }

  // Renderizar componente filho se estiver autenticado e tiver permissão
  return children;
};

export default ProtectedRoute;
